import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[550px] md:h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20dramatic%20red%20velvet%20curtains%2C%20warm%20golden%20stage%20lighting%2C%20luxurious%20classic%20cinema%20atmosphere%2C%20elegant%20film%20projector%20beams%2C%20rich%20dark%20red%20and%20gold%20color%20palette%2C%20art%20deco%20details&width=1920&height=900&seq=hero-caomin-cinema&orientation=landscape"
        alt="草民影院 - 高清电影在线观看"
        title="草民影院 - 蓝光1080P高清不卡在线观影"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/90 backdrop-blur-sm rounded-full mb-6">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
            <span className="text-white text-sm font-medium whitespace-nowrap">每日更新 · 海量资源</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
            高清电影 <span className="text-primary-400">&</span> 超清电视剧
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-4 max-w-2xl mx-auto leading-relaxed">
            蓝光画质1080P在线观看 · 高清不卡流畅不缓冲 · 即点即看
          </p>
          <p className="text-sm text-white/60 mb-8 max-w-xl mx-auto">
            海量影视资源每日更新，热门电影电视剧一网打尽，给你最好的在线观影体验
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/action"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <i className="ri-play-circle-line mr-1"></i>
              开始观影
            </Link>
            <Link
              to="/category/drama"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold rounded-full border border-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-tv-line mr-1"></i>
              热门剧集
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10 flex-wrap">
            {[
              { count: '10万+', label: '影视资源' },
              { count: '1080P', label: '蓝光画质' },
              { count: '99.9%', label: '不卡不缓冲' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.count}</div>
                <div className="text-xs text-white/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}